/**
 * Apartment details popup.
 *
 * Opens when a row of the Apartment Listings table is clicked, loads the
 * apartment data via admin-ajax (action: get_apartment_details) and fills the
 * popup shell rendered by the widget. Two tabs: "plan" (floor plan image) and
 * "map" (site plan — the interactive SVG mounts into [data-apt-map]).
 *
 * Events (triggered on the .apt-popup element):
 *   apt-popup:open    (event, apartmentId)
 *   apt-popup:loaded  (event, data)          data = AJAX payload
 *   apt-popup:tab     (event, tabName, data)  tabName = 'plan' | 'map'
 *   apt-popup:close   (event)
 *
 * The currently selected apartment is also exposed on
 * window.luigetiigiSelectedApartment.
 */
(function ($) {
	'use strict';

	var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

	var $active   = null; // currently open .apt-popup
	var current   = null; // data of the loaded apartment
	var lastFocus = null; // element to return focus to on close
	var xhr       = null;

	var CLOSE_FALLBACK_MS = 1100; // > the CSS exit animation (overlay ends at 0.85s)

	// ── Open ────────────────────────────────────────────────────────────────

	function open($listings, id, trigger) {
		var $popup = $listings.find('.apt-popup').first();
		if (!$popup.length || !id) {
			return;
		}

		if ($active && $active[0] !== $popup[0]) {
			close(false);
		}

		finishClose($popup);

		$active   = $popup;
		current   = null;
		lastFocus = trigger || document.activeElement;

		$popup
			.removeClass('has-error apt-popup--unavailable')
			.addClass('is-open is-loading')
			.attr('aria-hidden', 'false')
			.attr('data-apartment-id', id);

		$popup.find('[data-apt-field]').not('[data-apt-field="image"]').text('');
		$popup.find('[data-apt-field="image"]').empty();
		$popup.find('.apt-popup__error').prop('hidden', true);
		setDownload($popup, '');
		setCtaLinks($popup, null);

		// Default tab comes from the widget setting (data-default-tab: plan | map)
		switchTab($popup, $popup.data('default-tab') === 'map' ? 'map' : 'plan', false);

		$('html').addClass('apt-popup-open');
		$popup.find('.apt-popup__close').trigger('focus');
		$popup.trigger('apt-popup:open', [id]);

		if (xhr) {
			xhr.abort();
		}

		xhr = $.post(luigetiigi_ajax.ajax_url, {
			action:           'get_apartment_details',
			nonce:            luigetiigi_ajax.details_nonce,
			id:               id,
			heading_template: $listings.data('heading-template') || 'Korter {number}',
		})
			.done(function (response) {
				if (!response || !response.success) {
					showError($popup);
					return;
				}
				fill($popup, response.data);
			})
			.fail(function (jqXHR) {
				if (jqXHR.statusText !== 'abort') {
					showError($popup);
				}
			})
			.always(function () {
				xhr = null;
			});
	}

	function fill($popup, data) {
		current = data;
		window.luigetiigiSelectedApartment = data;

		$.each(['heading', 'address', 'building', 'size', 'rooms', 'floor', 'balcony', 'price'], function (_, key) {
			$popup.find('[data-apt-field="' + key + '"]').text(data[key] || '');
		});

		var $image = $popup.find('[data-apt-field="image"]');
		if (data.image_html) {
			$image.html(data.image_html);
		} else {
			$image.empty();
		}

		setDownload($popup, data.pdf_url || '');
		setCtaLinks($popup, data);

		$popup.toggleClass('apt-popup--unavailable', !!data.is_unavailable);
		$popup.removeClass('is-loading');
		$popup.trigger('apt-popup:loaded', [data]);
	}

	/**
	 * Point the "Lae alla" button at the apartment's own floor plan PDF, or at
	 * the widget's global fallback URL. Hidden when neither exists.
	 */
	function setDownload($popup, pdfUrl) {
		var $link = $popup.find('[data-apt-download="plan"]');
		if (!$link.length) {
			return;
		}
		var url = pdfUrl || $link.data('fallback-url') || '';
		$link.attr('href', url).prop('hidden', !url);

		var $wrap = $link.closest('.apt-popup__downloads');
		$wrap.prop('hidden', !$wrap.find('.apt-popup__download').filter(function () { return !this.hidden; }).length);
	}

	/**
	 * Add the apartment name to the "Võta ühendust" / "Broneeri" links as
	 * ?<data-param>=<title>, so the target page's form can prefill it.
	 * Without data (still loading) the links point at their plain page.
	 */
	function setCtaLinks($popup, data) {
		// Titles arrive with HTML entities (e.g. &#8211;); decode first.
		var name = data && data.title ? $('<textarea>').html(String(data.title)).text() : '';

		$popup.find('[data-apt-cta]').each(function () {
			var $link = $(this);
			var base  = String($link.data('base-url') || '');
			var param = String($link.data('param') || 'korter');

			if (!name || !base) {
				$link.attr('href', base || '#');
				return;
			}

			try {
				var url = new URL(base, window.location.href);
				url.searchParams.set(param, name);
				$link.attr('href', url.toString());
			} catch (e) {
				$link.attr('href', base);
			}
		});
	}

	function showError($popup) {
		$popup.removeClass('is-loading').addClass('has-error');
		$popup.find('.apt-popup__error').prop('hidden', false);
	}

	// ── Close ───────────────────────────────────────────────────────────────

	function close(restoreFocus) {
		if (!$active) {
			return;
		}

		if (xhr) {
			xhr.abort();
			xhr = null;
		}

		var $popup = $active;
		$active = null;

		// Stay visible (.is-closing) until the overlay's delayed fade-out ends;
		// the timer is a fallback for when animationend never fires.
		$popup
			.removeClass('is-open')
			.addClass('is-closing')
			.attr('aria-hidden', 'true')
			.removeAttr('data-apartment-id')
			.on('animationend.aptClose', '.apt-popup__overlay', function (event) {
				if (event.target === this) {
					finishClose($popup);
				}
			})
			.data('aptCloseTimer', setTimeout(function () {
				finishClose($popup);
			}, CLOSE_FALLBACK_MS));

		$popup.trigger('apt-popup:close');

		if (restoreFocus !== false && lastFocus && typeof lastFocus.focus === 'function') {
			lastFocus.focus();
		}
		lastFocus = null;
	}

	/** Hide a closing popup for good. No-op unless it is mid-close. */
	function finishClose($popup) {
		if (!$popup.hasClass('is-closing')) {
			return;
		}

		clearTimeout($popup.data('aptCloseTimer'));
		$popup
			.off('.aptClose')
			.removeData('aptCloseTimer')
			.removeClass('is-closing is-loading has-error');

		if (!$active) {
			$('html').removeClass('apt-popup-open');
		}
	}

	// ── Tabs ────────────────────────────────────────────────────────────────

	function switchTab($popup, name, notify) {
		$popup.find('.apt-popup__tab').each(function () {
			var isActive = $(this).data('apt-tab') === name;
			$(this)
				.toggleClass('is-active', isActive)
				.attr('aria-selected', isActive ? 'true' : 'false')
				.attr('tabindex', isActive ? '0' : '-1');
		});

		$popup.find('.apt-popup__pane').each(function () {
			var isActive = $(this).data('apt-pane') === name;
			$(this).toggleClass('is-active', isActive).prop('hidden', !isActive);
		});

		if (notify !== false) {
			$popup.trigger('apt-popup:tab', [name, current]);
		}
	}

	// ── Focus trap ──────────────────────────────────────────────────────────

	function trapFocus(event) {
		if (!$active || event.key !== 'Tab') {
			return;
		}

		var $focusable = $active.find(FOCUSABLE).filter(':visible');
		if (!$focusable.length) {
			event.preventDefault();
			return;
		}

		var first = $focusable[0];
		var last  = $focusable[$focusable.length - 1];

		if (event.shiftKey && document.activeElement === first) {
			event.preventDefault();
			last.focus();
		} else if (!event.shiftKey && document.activeElement === last) {
			event.preventDefault();
			first.focus();
		} else if (!$.contains($active[0], document.activeElement)) {
			event.preventDefault();
			first.focus();
		}
	}

	// ── Bindings ────────────────────────────────────────────────────────────

	// Row click (anywhere on the row, except links/buttons other than our own)
	$(document).on('click', '.apt-listings .apt-row', function (event) {
		var $target = $(event.target);
		var $own    = $target.closest('.apt-row__btn, [data-apt-open]');
		if ($target.closest('a, button').length && !$own.length) {
			return;
		}
		// Let users select text without opening the popup.
		var selection = window.getSelection ? String(window.getSelection()) : '';
		if (selection.length && event.detail > 1) {
			return;
		}

		var id = $(this).data('apartment-id');
		open($(this).closest('.apt-listings'), id, $own[0] || $(this).find('.apt-row__btn')[0] || this);
	});

	$(document).on('click', '.apt-popup [data-apt-close]', function (event) {
		event.preventDefault();
		close();
	});

	$(document).on('click', '.apt-popup__tab', function () {
		switchTab($(this).closest('.apt-popup'), $(this).data('apt-tab'));
	});

	$(document).on('keydown', '.apt-popup__tab', function (event) {
		if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
			return;
		}
		event.preventDefault();
		var $tabs = $(this).closest('.apt-popup__tabs').find('.apt-popup__tab');
		var index = $tabs.index(this);
		var next  = event.key === 'ArrowRight' ? (index + 1) % $tabs.length : (index - 1 + $tabs.length) % $tabs.length;
		$tabs.eq(next).trigger('focus').trigger('click');
	});

	// Clicking a CTA before the apartment has loaded would drop the name from the link.
	$(document).on('click', '.apt-popup [data-apt-cta]', function (event) {
		if ($(this).closest('.apt-popup').hasClass('is-loading')) {
			event.preventDefault();
		}
	});

	$(document).on('keydown', function (event) {
		if (!$active) {
			return;
		}
		if (event.key === 'Escape' || event.key === 'Esc') {
			event.preventDefault();
			close();
			return;
		}
		trapFocus(event);
	});

	// Public API for the site-plan script and other integrations.
	window.luigetiigiApartmentPopup = {
		open: function (id) {
			var $listings = $('.apt-listings').first();
			open($listings, id, null);
		},
		close:     close,
		switchTab: function (name) {
			if ($active) {
				switchTab($active, name);
			}
		},
		getCurrent: function () {
			return current;
		},
	};

})(jQuery);
